import axios from 'axios';
import apiconfig from '../../../apiconfig';

export default () => {
  const config = apiconfig[process.env.NODE_ENV];

  const headers = {
    'X-Api-Key': config.access.key,
  };

  const options = {
    baseURL: config.url,
    timeout: config.timeout,
    headers,
  };

  return axios.create(options);
};
